"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _multipassify = _interopRequireDefault(require("multipassify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var todaysDate = new Date();
/*
  Generate a Multipass customer route

  {param} string Shop URL, should contain a myshopify.com URL
  {param} string Shop Multipass secret key
  {param} string return_to URL string
  {returns} string a complete URI/URL for consumption
*/

var multipassCustomerRoute = function multipassCustomerRoute(shopURL, shopSecret) {
  var return_to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'https://bccs-dev-b2b.myshopify.com';
  var customerPayload = {
    email: 'pxuqa@protonmail.com',
    first_name: 'CI',
    last_name: 'Tester',
    phone: '555-573-2384',
    return_to: return_to,
    tag_string: 'attributes::guid::ea7c6864-6d03-35d6-8cf7-5b8ec29319d9, L::450005',
    created_at: todaysDate.toISOString(),
    addresses: [{
      zip: 'V6A 2S5',
      company: 'Automated Testing Corp.',
      province: 'British Columbia',
      address1: '212-123 Main St',
      country: 'Canada',
      city: 'Vancouver'
    }]
  };
  var multipassify = new _multipassify["default"](shopSecret);
  var generatedURL = multipassify.generateUrl(customerPayload, shopURL);
  return "".concat(generatedURL);
};

var _default = multipassCustomerRoute;
exports["default"] = _default;